import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { getSupportActivityQueryKey } from "modules/dashboard/lib/supportActivityQuery"
import { TicketStatusEnum } from "schema"
import { getConversationTicketsQueryKey } from "../lib/conversationTicketsQuery"

export function useUpdateConversationTicketStatusMutation(conversationTicketId: string) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (status: keyof typeof TicketStatusEnum) => {
      return axios.put(`/support/tickets/${conversationTicketId}/status`, {
        status,
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [getConversationTicketsQueryKey().at(0)],
      })

      queryClient.invalidateQueries({
        queryKey: getSupportActivityQueryKey(),
      })
    },
  })
}
